import z from "zod";
import { options } from "../constants.schema";

const validate_url = z
  .string()
  .optional()
  .refine((val) => !val || /^https?:\/\/.+$/.test(val), {
    message: "Must be a valid URL",
  });

export const userInformationSchema = z.object({
  first_name: z.string().nonempty("The first name is required."),
  last_names: z.string().nonempty("The last name is required."),
  location_country: z.object(options).refine((val) => val.id !== "", {
    message: "The location country is required.",
  }),
  location_state: z.object(options).refine((val) => val.id !== "", {
    message: "The location state is required.",
  }),
  phone_number: z
    .object({
      country_id: z.string().nonempty(),
      phone_number: z.string().min(4),
    })
    .refine((val) => val.country_id && val.phone_number, {
      message: "The phone number is required",
    }),
  job_area: z.object(options).optional(),
  job_title: z.string().optional(),
  cover_letter: z.string().optional(),
  linkedin_url: validate_url,
  find_jobbi: z.object(options).optional(),
  responsibility_level: z.object(options).optional(),
  picture_profile: z
    .union([z.instanceof(File), z.string(), z.null()])
    .optional(),
});

export type UserInformationType = z.infer<typeof userInformationSchema>;

export type UserInformationResponseType = UserInformationType & {
  picture_profile?: string;
};
